/* @bs-owned */
/*
 * bs-buy.js — motor de compra compartilhado dos templates bs-* (PDP do Body Shaper).
 *
 * Marcação (cada template estiliza do seu jeito):
 *   <div data-bs-buy data-bs-data="ID-DO-JSON" data-bs-default="kit2">      raiz
 *     [data-bs-offer-card="single|kit2|combo"]   cartão/aba de oferta (clique seleciona)
 *     [data-bs-options]                           onde o JS desenha cor e tamanho
 *     [data-bs-price] [data-bs-compare] [data-bs-save] [data-bs-installment] (+ data-bs-installment-suffix opcional, troca o " com juros") [data-bs-unit] (+ data-bs-unit-suffix opcional, troca o " por body" e vira <span class="bs-unit__suffix">)
 *     [data-bs-summary]                           "Kit 2 Bodys · Preto + Marrom · M"
 *     [data-bs-add]                               botão(ões) de comprar (pode haver o do sticky)
 *     [data-bs-error]                             mensagem de validação/erro
 *     [data-bs-main-image]                        <img> trocada ao mudar a cor (opcional)
 *   [data-bs-sticky]  barra fixa: recebe .is-visible quando o botão principal sai da tela
 *   [data-bs-delivery] prazo por região (geo.midastime.com.br): "Chega entre 02 e 08 de out"
 *   [data-bs-open="ID"] abre <dialog id="ID"> (guia de medidas etc.); [data-bs-close] fecha
 *
 * Carrinho: POST /cart/add.js e depois openCart() avisa o tema e abre a gaveta (midas-cart.js).
 * Tamanho nunca vem pré-selecionado (evita comprar o tamanho errado): o botão pede a escolha.
 */
(function () {
  'use strict';

  var SWATCH = {
    'marrom': '#5b3326', 'preto': '#1c1c1c', 'off white': '#ece5d8', 'bege': '#d9b99b', 'nude': '#d9b99b', 'branco': '#ffffff'
  };
  var MONTHS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  var HOLIDAYS = new Set([
    '2026-01-01', '2026-02-16', '2026-02-17', '2026-04-03', '2026-04-21', '2026-05-01', '2026-06-04',
    '2026-09-07', '2026-10-12', '2026-11-02', '2026-11-15', '2026-11-20', '2026-12-25',
    '2027-01-01', '2027-02-08', '2027-02-09', '2027-03-26', '2027-04-21', '2027-05-01', '2027-05-27',
    '2027-09-07', '2027-10-12', '2027-11-02', '2027-11-15', '2027-11-20', '2027-12-25'
  ]);
  var SOUTH_SOUTHEAST = new Set(['SP', 'RJ', 'MG', 'ES', 'PR', 'SC', 'RS']);

  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function optType(name) {
    if (/tamanho/i.test(name)) return 'size';
    if (/cor/i.test(name)) return 'color';
    return 'other';
  }
  function swatchFor(value) {
    var parts = value.toLowerCase().split('+').map(function (s) { return s.trim(); });
    var colors = parts.map(function (p) { return SWATCH[p] || '#cccccc'; });
    if (colors.length === 1) return colors[0];
    return 'linear-gradient(135deg, ' + colors[0] + ' 0 50%, ' + colors[1] + ' 50% 100%)';
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* ---------- Prazo de entrega (mesma regra da LP body-cc) ---------- */
  function addBusinessDays(start, days) {
    var d = new Date(start.getTime()), added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      if (d.getDay() !== 0 && d.getDay() !== 6 && !HOLIDAYS.has(iso)) added++;
    }
    return d;
  }
  function fmtDay(d) { return String(d.getDate()).padStart(2, '0') + ' de ' + MONTHS[d.getMonth()]; }
  var geoPromise = null;
  function initDelivery() {
    var nodes = document.querySelectorAll('[data-bs-delivery]');
    if (!nodes.length) return;
    function render(min, max, place) {
      var now = new Date();
      nodes.forEach(function (n) {
        var dates = n.querySelector('[data-bs-delivery-dates]') || n;
        dates.textContent = 'Chega entre ' + fmtDay(addBusinessDays(now, min)) + ' e ' + fmtDay(addBusinessDays(now, max));
        var loc = n.querySelector('[data-bs-delivery-place]');
        if (loc && place) loc.textContent = place;
      });
    }
    render(6, 10, '');
    geoPromise = geoPromise || fetch('https://geo.midastime.com.br/').then(function (r) { return r.json(); }).catch(function () { return null; });
    geoPromise.then(function (d) {
      if (!d || !d.region_code) return;
      var near = SOUTH_SOUTHEAST.has(d.region_code);
      render(near ? 4 : 6, near ? 8 : 10, (d.city ? d.city + ', ' : '') + d.region_code);
    });
  }

  /* ---------- Diálogos (guia de medidas etc.) ---------- */
  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-bs-open]');
      if (opener) {
        var dlg = document.getElementById(opener.getAttribute('data-bs-open'));
        if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
        return;
      }
      var closer = e.target.closest('[data-bs-close]');
      if (closer) { var d = closer.closest('dialog'); if (d) d.close(); return; }
      if (e.target.tagName === 'DIALOG' && e.target.hasAttribute('data-bs-dialog')) e.target.close();
    });
    // Um script do tema cancela o Esc nativo do <dialog>: fecha aqui os diálogos bs-*.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelectorAll('dialog[data-bs-dialog][open]');
      if (open.length) open[open.length - 1].close();
    });
  }

  /* ---------- Comprador ---------- */
  function Buy(root) {
    this.root = root;
    var src = document.getElementById(root.getAttribute('data-bs-data'));
    if (!src) return;
    this.data = JSON.parse(src.textContent);
    this.offers = {};
    var self = this;
    this.data.offers.forEach(function (o) { self.offers[o.key] = o; });
    var def = root.getAttribute('data-bs-default');
    this.offerKey = this.offers[def] ? def : this.data.offers[0].key;
    this.sel = { color: null, size: null };
    this.optionsBox = root.querySelector('[data-bs-options]');
    this.stickies = document.querySelectorAll('[data-bs-sticky]');

    root.querySelectorAll('[data-bs-offer-card]').forEach(function (card) {
      var key = card.getAttribute('data-bs-offer-card');
      if (!self.offers[key]) { card.hidden = true; return; }
      card.addEventListener('click', function (e) {
        if (e.target.closest('a[href]')) return;
        self.setOffer(key);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.setOffer(key); }
      });
    });
    document.querySelectorAll('[data-bs-add]').forEach(function (btn) {
      if (btn.closest('[data-bs-buy]') && btn.closest('[data-bs-buy]') !== root) return;
      btn.addEventListener('click', function (e) { e.preventDefault(); self.add(btn); });
    });
    this.setOffer(this.offerKey, true);
    this.initSticky();
    // Aviso de "motor pronto" (a 1ª renderização não dispara bs:change): templates podem ler o estado inicial.
    root.dispatchEvent(new CustomEvent('bs:ready', { bubbles: true, detail: { offer: this.offerKey, variant: this.variant(), selection: this.sel } }));
  }

  Buy.prototype.offer = function () { return this.offers[this.offerKey]; };

  Buy.prototype.setOffer = function (key, silent) {
    if (!this.offers[key]) return;
    this.offerKey = key;
    var o = this.offer();
    // Mantém cor/tamanho se existirem na nova oferta; cor cai para a primeira disponível.
    var colorIdx = o.options.findIndex(function (n) { return optType(n) === 'color'; });
    var sizeIdx = o.options.findIndex(function (n) { return optType(n) === 'size'; });
    if (colorIdx > -1) {
      var colors = this.values(colorIdx);
      if (colors.indexOf(this.sel.color) === -1) {
        var firstAvail = colors.find(function (c) { return o.variants.some(function (v) { return v.a && v.o[colorIdx] === c; }); });
        this.sel.color = firstAvail || colors[0];
      }
    }
    if (sizeIdx > -1 && this.values(sizeIdx).indexOf(this.sel.size) === -1) this.sel.size = null;
    this.root.querySelectorAll('[data-bs-offer-card]').forEach(function (card) {
      var on = card.getAttribute('data-bs-offer-card') === key;
      card.classList.toggle('is-active', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = on;
    });
    this.renderOptions();
    this.update(silent);
  };

  Buy.prototype.values = function (idx) {
    var seen = [];
    this.offer().variants.forEach(function (v) { if (seen.indexOf(v.o[idx]) === -1) seen.push(v.o[idx]); });
    return seen;
  };

  Buy.prototype.renderOptions = function () {
    if (!this.optionsBox) return;
    var self = this, o = this.offer();
    this.optionsBox.innerHTML = '';
    o.options.forEach(function (name, idx) {
      var type = optType(name);
      var group = el('div', 'bs-opt bs-opt--' + type);
      group.setAttribute('role', 'radiogroup');
      var head = el('div', 'bs-opt__head');
      var labelText = type === 'size' ? 'Tamanho' : (type === 'color' ? (o.units > 1 ? 'Cores do kit' : 'Cor') : name);
      var label = el('span', 'bs-opt__label', labelText + ':');
      var current = el('span', 'bs-opt__current', (type === 'color' ? self.sel.color : self.sel.size) || (type === 'size' ? 'escolha' : ''));
      label.id = 'bs-lbl-' + Math.random().toString(36).slice(2, 8);
      group.setAttribute('aria-labelledby', label.id);
      head.appendChild(label); head.appendChild(current);
      if (type === 'size') {
        var guide = self.root.getAttribute('data-bs-size-guide');
        if (guide) {
          var g = el('button', 'bs-opt__guide', 'Qual é o meu tamanho?');
          g.type = 'button';
          g.setAttribute('data-bs-open', guide);
          head.appendChild(g);
        }
        if (/\(/.test(name)) group.appendChild(el('p', 'bs-opt__note', name.replace(/^[^(]*\(|\)$/g, '')));
      }
      group.insertBefore(head, group.firstChild);
      var list = el('div', 'bs-opt__values');
      self.values(idx).forEach(function (val) {
        var btn = el('button', 'bs-opt__value' + (type === 'color' ? ' bs-opt__value--swatch' : ''));
        btn.type = 'button';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('data-value', val);
        if (type === 'color') {
          btn.style.setProperty('--bs-swatch', swatchFor(val));
          btn.setAttribute('aria-label', val);
          btn.title = val;
          btn.appendChild(el('span', 'bs-opt__swatch'));
        } else {
          btn.textContent = val;
        }
        btn.addEventListener('click', function () {
          if (type === 'color') self.sel.color = val; else if (type === 'size') self.sel.size = val;
          self.root.classList.remove('is-needs-size');
          self.update();
        });
        list.appendChild(btn);
      });
      group.appendChild(list);
      self.optionsBox.appendChild(group);
    });
  };

  Buy.prototype.variant = function () {
    var o = this.offer(), self = this;
    return o.variants.find(function (v) {
      return o.options.every(function (name, idx) {
        var t = optType(name);
        if (t === 'color') return v.o[idx] === self.sel.color;
        if (t === 'size') return v.o[idx] === self.sel.size;
        return true;
      });
    }) || null;
  };

  Buy.prototype.needsSize = function () {
    return this.offer().options.some(function (n) { return optType(n) === 'size'; }) && !this.sel.size;
  };

  Buy.prototype.installment = function (cents, suffix) {
    var n = this.data.installments || 0, r = this.data.rate || 0;
    if (!n) return '';
    var pmt = r > 0 ? cents * r * Math.pow(1 + r, n) / (Math.pow(1 + r, n) - 1) : cents / n;
    return n + 'x de ' + money(Math.round(pmt)) + (suffix != null ? suffix : (r > 0 ? ' com juros' : ' sem juros'));
  };

  Buy.prototype.update = function (silent) {
    var self = this, o = this.offer(), v = this.variant();
    var colorIdx = o.options.findIndex(function (n) { return optType(n) === 'color'; });
    var sizeIdx = o.options.findIndex(function (n) { return optType(n) === 'size'; });
    // Sem tamanho escolhido, a referência (preço e foto) é uma variante da cor escolhida.
    var sameColor = function (x) { return colorIdx === -1 || x.o[colorIdx] === self.sel.color; };
    var ref = v || o.variants.find(function (x) { return x.a && sameColor(x); }) || o.variants.find(sameColor) || o.variants.find(function (x) { return x.a; }) || o.variants[0];

    // Estados dos botões de opção (esgotado riscado, selecionado marcado).
    if (this.optionsBox) {
      this.optionsBox.querySelectorAll('.bs-opt').forEach(function (group, gi) {
        var type = optType(o.options[gi]);
        var chosen = type === 'color' ? self.sel.color : (type === 'size' ? self.sel.size : null);
        group.querySelector('.bs-opt__current').textContent = chosen || (type === 'size' ? 'escolha' : '');
        group.querySelectorAll('.bs-opt__value').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var on = val === chosen;
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
          btn.classList.toggle('is-active', on);
          var avail = o.variants.some(function (x) {
            if (!x.a || x.o[gi] !== val) return false;
            if (type === 'size' && colorIdx > -1) return x.o[colorIdx] === self.sel.color;
            if (type === 'color' && sizeIdx > -1 && self.sel.size) return x.o[sizeIdx] === self.sel.size;
            return true;
          });
          btn.classList.toggle('is-soldout', !avail);
          btn.setAttribute('aria-disabled', avail ? 'false' : 'true');
        });
      });
    }

    var price = ref.p, compare = ref.c > ref.p ? ref.c : 0;
    this.q('[data-bs-price]').forEach(function (n) { n.textContent = money(price); });
    this.q('[data-bs-compare]').forEach(function (n) { n.textContent = compare ? money(compare) : ''; n.hidden = !compare; });
    this.q('[data-bs-save]').forEach(function (n) {
      var pct = compare ? Math.round((compare - price) / compare * 100) : 0;
      n.hidden = !pct;
      if (pct) n.textContent = n.getAttribute('data-format') === 'money' ? 'Economize ' + money(compare - price) : pct + '% OFF';
    });
    this.q('[data-bs-installment]').forEach(function (n) { n.textContent = self.installment(price, n.getAttribute('data-bs-installment-suffix')); });
    this.q('[data-bs-unit]').forEach(function (n) {
      n.hidden = o.units < 2;
      if (o.units < 2) return;
      var unit = money(Math.round(price / o.units)), suffix = n.getAttribute('data-bs-unit-suffix');
      if (suffix == null) { n.textContent = unit + ' por body'; return; }
      var tail = document.createElement('span');
      tail.className = 'bs-unit__suffix'; tail.textContent = suffix;
      n.textContent = unit; n.appendChild(tail);
    });
    var names = { single: '1 Body Shaper', kit2: 'Kit 2 Bodys' };
    var summary = [names[o.key] || o.title];
    if (colorIdx > -1 && this.sel.color) summary.push(this.sel.color);
    if (this.sel.size) summary.push('Tam. ' + this.sel.size);
    this.q('[data-bs-summary]').forEach(function (n) { n.textContent = summary.join(' · '); });

    var soldout = v && !v.a;
    var state = this.needsSize() ? 'needs-size' : (soldout ? 'soldout' : 'ready');
    this.root.setAttribute('data-state', state);
    this.stickies.forEach(function (s) { s.setAttribute('data-state', state); });
    document.querySelectorAll('[data-bs-add]').forEach(function (btn) {
      var lbl = btn.querySelector('[data-bs-add-label]');
      if (!lbl) return;
      if (!btn.hasAttribute('data-label-ready')) btn.setAttribute('data-label-ready', lbl.textContent.trim());
      lbl.textContent = soldout ? 'Esgotado neste tamanho' : btn.getAttribute('data-label-ready');
    });

    // Imagem principal acompanha a cor (só na oferta de 1 body, que tem foto por cor).
    if (o.key === 'single' && ref.img) {
      this.q('[data-bs-main-image]').forEach(function (img) {
        if (img.getAttribute('data-bs-color') === self.sel.color) return;
        img.setAttribute('data-bs-color', self.sel.color || '');
        img.removeAttribute('srcset');
        img.src = ref.img;
      });
    }
    if (!silent) this.root.dispatchEvent(new CustomEvent('bs:change', { bubbles: true, detail: { offer: o.key, variant: v, selection: this.sel } }));
  };

  Buy.prototype.q = function (sel) {
    var list = Array.prototype.slice.call(this.root.querySelectorAll(sel));
    this.stickies.forEach(function (s) { list = list.concat(Array.prototype.slice.call(s.querySelectorAll(sel))); });
    return list;
  };

  Buy.prototype.error = function (msg) {
    this.q('[data-bs-error]').forEach(function (n) { n.textContent = msg || ''; n.hidden = !msg; });
  };

  // Gaveta do carrinho (assets/midas-cart.js, que substituiu o HS Slide Cart): não abre sozinha com o fetch.
  // Repete o que ela mesma faz — cart:updated + cart:refresh com a seção mini-cart e openMiniCart — e abre por garantia.
  // Falha aqui não vira erro para a cliente: o produto já entrou no carrinho.
  function openCart(sections) {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (sections) cart.sections = sections;
      var root = document.documentElement;
      root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
    }).catch(function (error) {
      console.error('Error in bs-buy openCart:', error);
    }).then(function () {
      if (window.MidasCart && typeof window.MidasCart.open === 'function') window.MidasCart.open();
      else if (typeof window.HS_SLIDE_CART_OPEN === 'function') window.HS_SLIDE_CART_OPEN();
    });
  }

  Buy.prototype.add = function (btn) {
    var self = this;
    if (btn.getAttribute('aria-busy') === 'true') return;
    if (this.needsSize()) {
      this.root.classList.add('is-needs-size');
      this.error('Escolha seu tamanho para continuar.');
      var group = this.optionsBox && this.optionsBox.querySelector('.bs-opt--size');
      if (group) {
        group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = group.querySelector('.bs-opt__value:not(.is-soldout)');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
      }
      return;
    }
    var v = this.variant();
    if (!v || !v.a) { this.error('Esse tamanho esgotou nesta cor. Escolha outra opção.'); return; }
    // Seletor de quantidade é opcional (só existe onde a seção liga): sem ele, segue 1.
    var qtyInput = this.root.querySelector('[data-bs-qty]');
    var qty = qtyInput ? Math.min(10, Math.max(1, parseInt(qtyInput.value, 10) || 1)) : 1;
    this.error('');
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: qty }], sections: 'mini-cart' })
    }).then(function (r) {
      // O HS Slide Cart intercepta o fetch e às vezes já consumiu o corpo: lê como texto e tolera falha.
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { /* corpo vazio ou já lido */ }
        return { ok: r.ok, status: r.status, body: j };
      }, function () { return { ok: r.ok, status: r.status, body: null }; });
    }).then(function (res) {
      if (!res.ok) {
        // 422 traz motivo legível em português (ex.: estoque); o resto vira mensagem amigável.
        var desc = res.status === 422 && res.body && (res.body.description || res.body.message);
        var fe = new Error(desc || 'Não foi possível adicionar agora. Tente de novo em instantes.');
        fe.bsFriendly = true;
        throw fe;
      }
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 2500);
      document.dispatchEvent(new CustomEvent('bs:added', { detail: { variant: v.id, offer: self.offerKey } }));
      return openCart(res.body && res.body.sections);
    }).catch(function (err) {
      // Nunca mostra erro técnico (ex.: "Failed to fetch") para a cliente.
      self.error(err && err.bsFriendly ? err.message : 'Não foi possível adicionar agora. Tente de novo em instantes.');
    }).then(function () {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    });
  };

  Buy.prototype.initSticky = function () {
    if (!this.stickies.length || !('IntersectionObserver' in window)) return;
    var self = this;
    var mains = Array.prototype.slice.call(this.root.querySelectorAll('[data-bs-add]'));
    if (!mains.length) return;
    // Mostra a barra só quando o botão principal ficou para trás (acima da tela).
    // Recalcula na rolagem também: um salto direto (âncora, "voltar ao topo") não cruza o botão
    // e o IntersectionObserver sozinho não dispararia.
    var ticking = false;
    function refresh() {
      ticking = false;
      var show = mains.every(function (m) {
        var r = m.getBoundingClientRect();
        if (!r.width && !r.height) return true; // botão escondido (ex.: dentro de diálogo fechado)
        return r.bottom < 0;
      });
      self.stickies.forEach(function (s) { s.classList.toggle('is-visible', show); });
    }
    var io = new IntersectionObserver(refresh);
    mains.forEach(function (m) { io.observe(m); });
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(refresh); }
    }, { passive: true });
    refresh();
  };

  /* Capa por oferta (26/10/2026): a galeria com data-bsb-cover-swap mostra a capa do produto do kit
     (a arte do combo) na oferta do kit e a capa de 1 peça na oferta de 1 unidade. Troca só a imagem
     da foto em data-bsb-cover-swap.pos; a ordem da galeria continua a mesma. */
  function initCoverSwap() {
    document.querySelectorAll('[data-bsb-cover-swap]').forEach(function (gal) {
      if (gal.__bsbCover) return;
      var cfg;
      try { cfg = JSON.parse(gal.getAttribute('data-bsb-cover-swap')); } catch (e) { return; }
      if (!cfg || !cfg.kit) return;
      gal.__bsbCover = true;
      var pos = cfg.pos == null ? '' : '[data-bsb-pos="' + cfg.pos + '"]';
      var main = (pos && gal.querySelector('[data-bsb-slide]' + pos + ' img')) || gal.querySelector('[data-bs-main-image]');
      var parts = [
        [main, 'img'],
        [pos ? gal.querySelector('[data-bsb-thumb]' + pos + ' img') : null, 'thumb']
      ];
      // Sem "base" no atributo, a capa de 1 peça é a que o tema já renderizou.
      var base = cfg.base || { img: main && main.getAttribute('src'), thumb: parts[1][0] && parts[1][0].getAttribute('src') };
      var paint = function (offer) {
        var side = (offer && offer !== 'single') ? cfg.kit : base;
        parts.forEach(function (p) {
          var img = p[0], url = side[p[1]];
          if (!img || !url || img.getAttribute('src') === url) return;
          img.removeAttribute('srcset');
          img.setAttribute('src', url);
        });
      };
      var handler = function (e) { paint(e.detail && e.detail.offer); };
      document.addEventListener('bs:change', handler);
      document.addEventListener('bs:ready', handler);
      window.addEventListener('load', function () { if (base.img) new Image().src = base.img; if (cfg.kit.img) new Image().src = cfg.kit.img; });
    });
  }

  function boot() {
    initDialogs();
    initDelivery();
    initCoverSwap();
    document.querySelectorAll('[data-bs-buy]').forEach(function (root) {
      if (root.__bsBuy) return;
      root.__bsBuy = new Buy(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
